<template>
  <div class="load_div">
    <ImageAnnotator
      :pureViewMode="true"
      :imageUrl="$store.state.baseUrl + activeItem.filepath"
      :initialLabels="initialAnnotations"
      style="width: 100%;height: 100%;position: absolute;left:0;top:0;"
      v-if="
        activeItem &&
          activeItem.file_type == 1 &&
          $router.currentRoute.name == 'DigitalTwin'
      "
    ></ImageAnnotator>
    <img
      id="model_load_img"
      :src="activeItem ? $store.state.baseUrl + activeItem.filepath : ''"
      v-else-if="activeItem && activeItem.file_type == 1"
    />
    <video
      id="model_load_video"
      :src="activeItem ? $store.state.baseUrl + activeItem.filepath : ''"
      v-else-if="activeItem && activeItem.file_type == 2"
      controls="controls"
      disablePictureInPicture="true"
      controlslist="nodownload noremoteplayback"
    ></video>
    <div id="model_load_div" v-else></div>
  </div>
</template>

<script>
import {
  GetZhgdbackground,
  GetMechanicalstdList,
  GetBackgrounddevices,
} from "@/setAxios";
export default {
  name: "RH_BIM_MODEL",
  props: {
    type: {
      type: [String, Number],
      default: "1",
    },
  },
  data() {
    return {
      activeItem: null,
      initialAnnotations: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.GetZhgdbackgroundFC();
  },
  methods: {
    isLoadModel() {
      if (!RHViewer.ModelLoadEnd) this.$message.warning("请等待模型加载完毕！");
      return RHViewer.ModelLoadEnd;
    },
    GetBackgrounddevicesFC(row) {
      GetBackgrounddevices({
        xid: this.$store.state.xid || localStorage.getItem("xid"),
        backgroundid: row.id,
        searchword: "",
      }).then((res) => {
        this.initialAnnotations = res.Data.map((item) => {
          return {
            ...item,
            ...JSON.parse(item.position),
          };
        });
      });
    },
    GetZhgdbackgroundFC() {
      GetZhgdbackground({
        xid: this.$store.state.xid || localStorage.xid,
        type: this.type,
        pageIndex: 1,
        pageSize: 9999,
        searchword: "",
      }).then((res) => {
        if (res.Code > 0) {
          this.activeItem = res.Data.find((item) => item.isup == 1);
          if (this.activeItem) {
            if (this.activeItem.file_type == 1) {
              this.GetBackgrounddevicesFC(this.activeItem);
            } else if (this.activeItem.file_type == 2) {
            } else {
              this.initModel(this.activeItem);
            }
          } else {
            this.$message.warning({
              message: "请先设置背景!",
              duration: 500,
            });
          }
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    labelLoad(data) {
      var Interval = setInterval(() => {
        if (RHViewer.ModelLoadEnd) {
          clearInterval(Interval);
          data.forEach(async (item, inx) => {
            if (item.position) {
              item.position = JSON.parse(item.position);
              item.dbId = item.position.dbId;
              item.fragId = item.position.fragId;
              item.name = item.labelname;
              item.type = item.devicetype;
              if (inx == data.length - 1) {
                RHViewer.lableLoad(data);
              }
            }
          });
        }
      }, 500);
    },
    initModel(data) {
      this.$nextTick(() => {
        RHViewer.localServerModels(
          "model_load_div",
          this.$store.state.baseUrl +
            (this.activeItem.filepath || data.filepath)
        );
      });
    },
    position(row) {
      if (RHViewer.ModelLoadEnd && row.position) {
        RHViewer.view.fitToView(row.position.dbId);
        RHViewer.view.select(row.position.dbId);
      } else {
        this.$message.warning("请等待模型加载完毕！");
      }
    },
  },
  components: {},
};
</script>

<style scoped>
#model_load_div,
#model_load_img,
#model_load_video {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  background-color: #00000055;
  overflow: hidden;
}
.load_div {
  width: 100%;
  height: 100%;
}
</style>
